var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignUp5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 1140,
    viewBox: "0 0 900 1140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M900 1140V0H0C94.3965 52.0538 383.405 387.196 230.338 730.783C21.8834 1198.7 683.681 1131.55 900 1140Z",
    fill: "url(#paint0_radial_747_10058)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_747_10058",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(450 570) rotate(90) scale(570 450)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#FF9F59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF994F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUp5);
export default __webpack_public_path__ + "static/media/signUp5.d63afd8b3edc99514a56b3621e535290.svg";
export { ForwardRef as ReactComponent };